import { createContext, type FC, type PropsWithChildren, useContext, useState } from "react";

type StoredViewMenuContextType = {
  localStoredViewId: string | null | undefined;
  setLocalStoredViewId: (id: string | null | undefined) => void;
};

const StoredViewMenuContext = createContext<StoredViewMenuContextType | null>(null);

export const StoredViewMenuProvider: FC<PropsWithChildren> = ({ children }) => {
  const [localStoredViewId, setLocalStoredViewId] = useState<string | null | undefined>(undefined);
  return (
    <StoredViewMenuContext.Provider value={{ localStoredViewId, setLocalStoredViewId }}>
      {children}
    </StoredViewMenuContext.Provider>
  );
};

export const useStoredViewMenuContext = () => {
  const context = useContext(StoredViewMenuContext);
  if (!context) throw new Error("useStoredViewMenuContext must be used within StoredViewMenuProvider");
  return context;
};
